module.exports = __webpack_public_path__ + "17b96430bcf3836cea10f40146b4701c.svg";